export const LANG_CODES = {
    ENGLISH: 'en-GB',
    GERMAN: 'de-CH',
    FRENCH: 'fr-CH',
} as const;

export type LangCode = ValueOf<typeof LANG_CODES>;

export type ContentLanguage = Exclude<LangCode, typeof LANG_CODES.ENGLISH>;
